import styled from 'styled-components';

export const StyledTwoFactorPage = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.background.main};
  border-radius: ${({ theme }) => theme.radius.small};
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  padding: 1rem;
  margin: 1.8rem auto;
  gap: 2rem;
  max-width: 492px;

  @media screen and (min-width: ${({ theme }) => theme.sizes.sm}) {
    padding: 3.2rem;
    margin: 3.2rem auto;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    padding: 3.2rem;
    margin: 4.6rem auto;
  }
`;
